import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import PageNotFound from '~/commons/components/PageNotFound.jsx';
import {
  PageLogin,
  PagePwdReset,
  PagePwdResetMail,
  PageRegister,
  PageVerifyUser,
  PageContact,
} from './pages';

const Auth = () => (
  <div className="d-flex content-100">
    <div className="my-auto w-100">
      <Router>
        <Switch>
          <Route path="/auth/pwd-recovery">
            <PagePwdResetMail />
          </Route>
          <Route path="/auth/pwd-reset">
            <PagePwdReset />
          </Route>
          <Route path="/auth/register">
            <PageRegister />
          </Route>
          <Route path="/auth/contact">
            <PageContact />
          </Route>
          <Route path="/auth/verify">
            <PageVerifyUser />
          </Route>
          <Route exact path="/auth/">
            <PageLogin />
          </Route>
          <Route path="*">
            <PageNotFound />
          </Route>
        </Switch>
      </Router>
    </div>
  </div>
);

export default Auth;
